import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppLayout } from "@/components/AppLayout";

import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import MRManagement from "@/pages/admin/MRManagement";
import TemplateManagement from "@/pages/admin/TemplateManagement";
import GeneratedVideos from "@/pages/admin/GeneratedVideos";
import MRDashboard from "@/pages/mr/MRDashboard";
import UploadVideo from "@/pages/mr/UploadVideo";
import MyVideos from "@/pages/mr/MyVideos";

const RootRedirect = () => {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/mr"} replace />;
};

const Admin = ({ children }) => (
  <ProtectedRoute role="admin">
    <AppLayout>{children}</AppLayout>
  </ProtectedRoute>
);
const MR = ({ children }) => (
  <ProtectedRoute role="mr">
    <AppLayout>{children}</AppLayout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />

            <Route path="/admin" element={<Admin><AdminDashboard /></Admin>} />
            <Route path="/admin/mrs" element={<Admin><MRManagement /></Admin>} />
            <Route path="/admin/template" element={<Admin><TemplateManagement /></Admin>} />
            <Route path="/admin/videos" element={<Admin><GeneratedVideos /></Admin>} />

            <Route path="/mr" element={<MR><MRDashboard /></MR>} />
            <Route path="/mr/upload" element={<MR><UploadVideo /></MR>} />
            <Route path="/mr/videos" element={<MR><MyVideos /></MR>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
